import { Col, Form, Modal, Row } from 'antd';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';

const StyledDiv = styled.div``;

interface CreateExpenseCommentModalProps {
  visible: boolean;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function CreateExpenseCommentModal({
  visible,
  onCreate,
  onCancel,
}: CreateExpenseCommentModalProps) {
  const [form] = Form.useForm();
  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="설명 추가"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Row justify="center">
            <Col span={12}>
              <Form form={form} layout="vertical" initialValues={{}}>
                <Form.Item
                  name="description"
                  label="설명"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default CreateExpenseCommentModal;
